import styled from 'styled-components';

const Container = styled.div`
  padding: 40px 52px 16px 36px;
  display: flex;
  justify-content: space-between;
  font-family: "Helvetica Neue", Arial, sans-serif;
  background-color: #0F1927;
`;

export default Container;
